<template>

  <div class="elevation-4">
    <v-toolbar flat="flat">
      <v-toolbar-title>Labels</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="700px">
        <v-icon medium="medium" slot="activator">mdi-plus</v-icon>
        <v-card>
          <v-card-title class="headline">Add a label</v-card-title>
          <v-card-text>
            <v-container fluid="fluid" grid-list-xl="grid-list-xl">
              <v-flex>
                <v-text-field v-model="editedLabel.locale" label="Locale" placeholder="Locale"></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field v-model="editedLabel.label" label="Label" placeholder="Label"></v-text-field>
              </v-flex>
              <v-flex>
                <div class="error-message">{{ errorMessage }}</div>
              </v-flex>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat="flat" @click.native="close">Cancel</v-btn>
            <v-btn color="primary" flat="flat" @click.native="save">Create</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table hide-headers="hide-headers" hide-actions="hide-actions" :loading="loading" :items="labelValues">
      <template slot="items" slot-scope="props">
        <tr>
          <td>{{ props.item.locale }}</td>
          <td>{{ props.item.value }}</td>
          <td class="label-action">
            <v-icon class="mr-2" title="Delete" @click="deleteLabel(props.item)">mdi-delete</v-icon>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>

</template>

<script>

export default {
  name: 'SportLabels',
  props: ['id', 'loading'],
  data: () => ({
    editedLabel: {
      locale: null,
      label: null
    },
    editedValue: null,
    dialog: null,
    errorMessage: ''
  }),
  computed: {
    labelValues () {
      const sport = this.$store.state.sports[this.id]

      if (sport === undefined) {
        return []
      }

      return Object.keys(sport.labels).map(k => ({
        locale: k,
        value: sport.labels[k]
      }))
    }
  },
  methods: {
    deleteLabel (label) {
      if (label === 'default') {
        return window.alert('You cannot delete the default label')
      }

      const labels = {}

      labels[label.locale] = null

      this.$store.dispatch('patchSport', {
        id: this.id,
        patch: {labels}
      })
    },

    createLabel () {
      if (!this.editedLabel.locale) {
        this.errorMessage = 'You must enter a locale'
        return
      }

      if (!this.editedLabel.label) {
        this.errorMessage = 'You must enter a label'
        return
      }

      for (const l of this.labelValues) {
        if (l.locale === this.editedLabel.locale) {
          this.errorMessage = 'This locale is already in use'
          return
        }
      }

      const labels = {}
      labels[this.editedLabel.locale] = this.editedLabel.label

      this.$store.dispatch('patchSport', {
        id: this.id,
        patch: {labels}
      })
        .then(() => this.close())
    },

    close () {
      this.dialog = false
      this.editedLabel = {
        locale: null,
        label: null
      }
      this.editedValue = null
      this.errorMessage = ''
    },

    save () {
      if (this.editedValue === null) {
        this.createLabel()
      } else {
        this.editLabel()
        this.close()
      }
    }
  }
}

</script>

<style lang="scss" scoped>

.label-action {
  width: 50px;
}

</style>



// WEBPACK FOOTER //
// src/pages/sport/SportLabels.vue